<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M13.3346 17.5391V4.20573C13.3346 3.7637 13.159 3.33978 12.8465 3.02722C12.5339 2.71466 12.11 2.53906 11.668 2.53906H8.33464C7.89261 2.53906 7.46869 2.71466 7.15612 3.02722C6.84356 3.33978 6.66797 3.7637 6.66797 4.20573V17.5391"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M16.668 5.875H3.33464C2.41416 5.875 1.66797 6.62119 1.66797 7.54167V15.875C1.66797 16.7955 2.41416 17.5417 3.33464 17.5417H16.668C17.5884 17.5417 18.3346 16.7955 18.3346 15.875V7.54167C18.3346 6.62119 17.5884 5.875 16.668 5.875Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconSuitcase',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
